import { useDependencies } from '@servicetitan/react-ioc';
import { observer } from 'mobx-react';
import { FC, ReactElement } from 'react';
import { PortalAuthStore } from '../../auth/stores/portal-auth.store';
import { LegalAgreementView } from './legal-agreement-view';

export const LegalAgreementGate: FC<{ children: ReactElement }> = observer(({ children }) => {
    const [{ mustAcceptLatestAgreement }] = useDependencies(PortalAuthStore);
    return mustAcceptLatestAgreement ? <LegalAgreementView /> : children;
});
